import packageInfo from '../../package.json';
import { LogLevel } from '../app/shared/services/logging/LogLevelEnum';
import { authorizeNet } from './environment.authorize-net';

// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
export const environment = {
    environment: 'staging (v19.6.1)',
    acceptedFiles: ".pdf,.jpg,.jpeg,.gif,.png,.webp,.svg,.bmp,.doc,.docx,.xls,.xlsx,.csv",
    local: false,
    production: false,
    apiLocation: 'https://mvcservices.efc-test.com/efaactcentral/api', // staging api
    // apiLocation: 'https://mvcservices.efc-test.com/efaactcentral/api',  // staging "production" api
    // apiLocation: 'https://mvcservices.efaactcentral.com/efaactcentral/api', // production api
    reportsLocation: 'https://reports.efc-test.com/displayreporteFC.aspx', // staging reports api
    // reportsLocation: 'https://reports.efaactcentral.com/displayreporteFC.aspx', // production reports api
    logLevel: LogLevel.All,
    // logLevel: LogLevel.Info,
    defaultMaxReports: 6,
    version: packageInfo.version,
    dropdownItemHeight: 19,
    flags: {
        // feature flags
        postingItem: false,
        'manageUsers-sendUserCredentials': true,
        forgotPassword: true,
        advisorSwitch: false,
        hideHolidayAuths: true,
        projectBudgetForecast: false,
        qboReleaseDate: true,
        qboresend: true,
        projectBudgetDownload: false,
        ffInactivatePayrollItems: true
    },
    currencyFormatter: new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
    }),
    authorizeNet
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
